import { useStoreInfo } from "../../context/StoreInfoContext";
import { useAuth } from "../../context/AuthContext";
import { Navigate, useLocation } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { useTheme } from "../../theme/ThemeContext";

const PublicRoute = ({ children }) => {
  const { storeInfo, loading: storeLoading } = useStoreInfo();
  const { user, loading: authLoading } = useAuth();
  const location = useLocation();
  const theme = useTheme();
  // Show loading spinner while either store info or auth is loading
  if (storeLoading || authLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          backgroundColor: theme?.store_background_color,
        }}
      >
        <CircularProgress size={60} />
      </Box>
    );
  }

  // If store is private and user is logged in, redirect to home
  // This prevents logged-in users from accessing login/register pages
  if (storeInfo?.store?.is_public === 0 && user) {
    return <Navigate to={`/${location.search || ""}`} replace />;
  }

  return children;
};

export default PublicRoute;
